import React from "react";
import {Container, Row, Col} from "shards-react";
import {connect} from "react-redux";
import moment from 'moment';
// Components
import PageTitle from "./../../components/common/PageTitle";
import TableData from "./../../components/tables";
import {Link} from "react-router-dom";

import {searchPractitioners, requestPractitioners} from '../../actions/practitioners.action';

class Practitioners extends React.Component {
  constructor(props) {
    super(props);
    this.props.loadData();
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle title="Praticiens" subtitle="Praticiens" className="text-sm-left mb-3"/>
        </Row>
        <Row>
          <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
            {this.props.practitioners.fetching ? (
              <div className="flex-center">
                <div className="text-center d-block">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
                <TableData
                    research={this.props.practitioners.searching}
                    tableData="practitioners"
                    dataColumns={[
                        {
                            Header: "Prénom",
                            accessor: "firstname",
                            maxWidth: 140,
                            className: "text-center",
                            Cell: row => (
                                <Link to={'/praticiens/' + row.original.id + '/profil/connect'}>
                                    <div
                                        className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                    />
                                    <span className="table__filter__practitioner">{row.original.first_name}</span>
                                </Link>
                            ),
                        },
                        {
                            Header: "Nom",
                            accessor: "lastname",
                            maxWidth: 140,
                            className: "text-center",
                            Cell: row => (
                                <Link to={'/praticiens/' + row.original.id + '/profil/connect'}>
                                    <div
                                        className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                    />
                                    <span className="table__filter__practitioner">{row.original.last_name}</span>
                                </Link>
                            ),
                        },
                        {
                            Header: "Email",
                            accessor: "email",
                            className: "text-center",
                            Cell: row => (
                                <Link to={'/praticiens/' + row.original.id + '/profil/connect'}>
                                    <div
                                        className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                    />
                                    <span className="table__filter__practitioner"
                                          title={row.original.email}>{row.original.email}</span>
                                </Link>
                            ),
                        },
                        {
                            Header: "Téléphone",
                            accessor: "mobile",
                            maxWidth: 200,
                            className: "text-center",
                            Cell: row => (
                                <Link to={'/praticiens/' + row.original.id + '/profil/connect'}>
                                    <div
                                        className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                    />
                                    <span className="table__filter__practitioner">{row.original.phone}</span>
                                </Link>
                            ),
                        },
                        {
                            Header: "Spécialité",
                            accessor: "speciality",
                            className: "text-center",
                            maxWidth: 170,
                            Cell: row => (
                                <div>
                                    <div
                                        className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                    />
                                    <span
                                        className="table__filter__practitioner">{row.original.main_specialty ? row.original.main_specialty.name : ''}</span>
                                </div>
                            ),
                        },
                        {
                            Header: () => (
                                <div>
                                    <span>Consultations</span>
                                    <br/>
                                    <small className="subtitle">Mois précédent / Mois actuel</small>
                                </div>
                            ),
                            maxWidth: 140,
                            className: "text-center",
                            Cell: row => (
                                <div>
                                    <div
                                        className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                    />
                                    <span
                                        className="table__filter__practitioner">{row.original.appointments_previous_month} / {row.original.appointments_this_month}</span>
                                </div>
                            ),
                        },
                        {
                            Header: "Dernière modif.",
                            accessor: "updated_at",
                            className: "text-center",
                            maxWidth: 110,
                            Cell: row => (
                                <span
                                    className="table__filter__practitioner">{row.original.updated_at ? (moment(row.original.updated_at).format("DD/MM/YYYY")) : ('Date Invalide')}</span>
                            )
                        },
                        {
                            Header: "Inscription",
                            accessor: "created_at",
                            className: "text-center",
                            maxWidth: 110,
                            Cell: row => (
                                <span
                                    className="table__filter__practitioner">{row.original.created_at ? (moment(row.original.created_at).format("DD/MM/YYYY")) : ('Date Invalide')}</span>
                            )
                        }
                    ]}
                    pageSize={20}
                    title={"Liste des praticiens"}
                    dataSearch={searchPractitioners}
                    dataName={'practitioners'}
                />
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}


function mapStateToProps(state) {
  return {
    practitioners: state['practitioners'],
  };
}

const mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(requestPractitioners())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Practitioners);



// WEBPACK FOOTER //
// ./src/views/Practitioners/Practitioners.js